import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { ImageLoadDirective } from '@directives/image-load.directive';
import { SadmEntityNamePipe } from '@modules/sadm/pipes/sadm-entity-name.pipe';
import { SadmEntityTypePipe } from '@modules/sadm/pipes/sadm-entity-type.pipe';
import { ArchivedBadgeComponent } from '@modules/shared/archived-badge/archived-badge.component';
import { ImageBrokenComponent } from '@modules/shared/image-broken/image-broken.component';
import { ImageLoadingComponent } from '@modules/shared/image-loading/image-loading.component';
import { getMediaPreviewUri, SadmType } from '@pixacare/domain';
import { SadmEntityResponse } from '@pixacare/dtos';
import { TuiBadge } from '@taiga-ui/kit';

@Component({
  selector: 'pxc-sadm-entity-preview',
  templateUrl: './sadm-entity-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DatePipe,
    SadmEntityNamePipe,
    SadmEntityTypePipe,
    ImageBrokenComponent,
    ImageLoadingComponent,
    ImageLoadDirective,
    ArchivedBadgeComponent,
    TuiBadge,
  ],
  providers: [SadmEntityTypePipe, SadmEntityNamePipe],
  host: {
    class: 'block',
  },
})
export class SadmEntityPreviewComponent {
  readonly sadmEntity = input<SadmEntityResponse>(null);
  readonly sadmType = input<SadmType>(null);

  protected readonly isLoaded = signal(false);
  protected readonly hasLoadError = signal(false);

  protected readonly previewUri = computed(() => getMediaPreviewUri(this.sadmEntity()?.previewMedia));

  onImageLoaded(): void {
    this.isLoaded.set(true);
    this.hasLoadError.set(false);
  }

  onImageLoadingError(): void {
    this.hasLoadError.set(true);
  }
}
